import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, TemplateRef, viewChild } from '@angular/core';
import { CarouselArrowsComponent } from 'src/app/home-page/components/carousel-arrows/carousel-arrows.component';
import { CarouselBaseComponent } from 'src/app/home-page/components/carousel-base/carousel-base.component';
import { ProductCardComponent } from '@core/components/product-card/product-card.component';
import { SectionTitleComponent } from 'src/app/home-page/components/section-title/section-title.component';
import { take } from 'rxjs';
import { CarouselService } from 'src/app/home-page/services/carousel.service';
import { CarouselItemBase } from 'src/app/home-page/components/carousel-base/carousel-item-base.model';
import { ILatestNews } from 'src/app/home-page/services/interfaces/ILatestNews';
import { SwiperOptions } from 'swiper/types';
import { CAROUSEL_BASE_DEFAULT_CONFIG } from 'src/app/home-page/components/carousel-base/carousel-base.default-config';
import { Autoplay, Grid, Pagination } from 'swiper/modules';

@Component({
  selector: 'cgw-latest-news-section',
  standalone: true,
  imports: [
    CommonModule,
    SectionTitleComponent,
    CarouselArrowsComponent,
    ProductCardComponent,
    CarouselBaseComponent,
  ],
  templateUrl: './latest-news-section.component.html',
  styleUrl: './latest-news-section.component.scss',
})
export class LatestNewsComponentSection implements OnInit {
  private readonly _productTemplateRef = viewChild('productTemplate', { read: TemplateRef });

  public readonly carousel =
    viewChild<CarouselBaseComponent<ILatestNews, CarouselItemBase<ILatestNews>>>(
      CarouselBaseComponent,
    );
  public readonly carouselConfig = signal<SwiperOptions>({
    ...CAROUSEL_BASE_DEFAULT_CONFIG,
    modules: [Autoplay, Pagination, Grid],
    slidesPerView: 1,
    spaceBetween: 10,
    grid: {
      rows: 2,
      fill: 'row',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
      992: {
        slidesPerView: 3,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
      1400: {
        slidesPerView: 3,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
    },
  });
  public readonly carouselItems = signal<CarouselItemBase<ILatestNews>[]>([]);

  constructor(private carouselService: CarouselService) {}

  public ngOnInit(): void {
    this.carouselService
      .getLatestNews()
      .pipe(take(1))
      .subscribe((latestNewsArr) => {
        this.carouselItems.set(
          latestNewsArr.map(
            (latestNews) =>
              new CarouselItemBase({
                id: latestNews.id_producto,
                data: latestNews,
                templateRef: this._productTemplateRef(),
                templateContext: { item: latestNews.producto },
              }),
          ),
        );
      });
  }
}
